import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import AiChatPanel from '#layers/ai/components/AiChat/Panel.vue';
import AiChatToggleButton from '#layers/ai/components/AiChat/ToggleButton.vue';
import { useAiStore } from '#layers/ai/stores/ai';
import { usePanel } from '#layers/ui/public';

export const useAiPanel = () => {
	const { t } = useI18n();
	const { showAiPanel } = storeToRefs(useAiStore());

	usePanel(
		{
			id: 'ai-chat',
			label: t('ai.assistant'),
			toggleComponent: AiChatToggleButton,
			component: AiChatPanel,
			order: 100,
		},
		{ enabled: showAiPanel },
	);
};
